import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Mail } from "lucide-react";

const EMAIL_KEY = "str_alert_email";

export function EmailAlertDialog({ open, onOpenChange, title, description, cta = "Subscribe", onSubmit }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) setEmail(localStorage.getItem(EMAIL_KEY) || ""); }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    localStorage.setItem(EMAIL_KEY, email);
    try { await onSubmit(email); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-none border-2 border-ink bg-paper shadow-hardlg" data-testid="alert-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading font-black text-2xl tracking-tighter">{title}</DialogTitle>
          <DialogDescription className="font-mono text-xs text-subtle">{description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="font-mono text-[11px] uppercase tracking-wider text-subtle">Email Address</span>
            <input
              data-testid="alert-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="mt-1 w-full border border-ink h-11 px-3 font-mono text-sm focus:outline-none focus:ring-2 focus:ring-ink"
            />
          </label>
          <button
            data-testid="alert-submit"
            disabled={busy}
            className="w-full bg-ink text-paper h-12 font-mono text-sm uppercase tracking-[0.15em] shadow-hard hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-transform disabled:opacity-50 flex items-center justify-center gap-2"
          >
            <Mail className="h-4 w-4" /> {busy ? "Saving…" : cta}
          </button>
          <p className="font-mono text-[10px] text-subtle text-center">Opt-in only · unsubscribe anytime from any email.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
